import {Avatar as AntAvatar} from "antd";

export const Avatar = AntAvatar;
export default Avatar;
